export function clientContactIds(project = {}) {
    if (Array.isArray(project.client_pics)) return project.client_pics.map(contact => Number(contact.id));
    if (Array.isArray(project.project_client_contact) && project.project_client_contact.length) {
        return [...project.project_client_contact].sort((a, b) => a.position - b.position).map(row => Number(row.client_contact_id));
    }
    const value = project.client_pic_id || project.client_person_in_charge_id || project.clientPersonInCharge;
    return (Array.isArray(value) ? value : value ? [value] : []).map(Number);
}

export function clientContactsForDisplay(project = {}) {
    if (Array.isArray(project.client_pics) && project.client_pics.length) return project.client_pics;
    if (project.project_client_contact?.length) {
        return [...project.project_client_contact].sort((a, b) => a.position - b.position).map(row => ({
            id: row.client_contact_id,
            full_name: `${row.client_contact?.first_name || ''} ${row.client_contact?.last_name || ''}`.trim()
        }));
    }
    return project.client_pic_id ? [{ id: project.client_pic_id, full_name: project.clientPic?.full_name || project.client_pic_name || '-' }] : [];
}
